import * as React from 'react';
import { ApiError } from '@collaborator/npm_modules/dist/modules/base/errors/ApiError';
import ErrorStackParser from 'error-stack-parser';
import stringify from 'json-stringify-pretty-compact';
import app from 'srcJs/App';

var ErrorFallback = function ErrorFallback(_ref) {
  var error = _ref.error;

  var printError = function printError() {
    if (app.isProduction()) {
      return null;
    }

    var stackFrames = ErrorStackParser.parse(error).map(function (stackFrame) {
      return /*#__PURE__*/React.createElement("li", {
        key: stackFrame.fileName + stackFrame.functionName
      }, stringify(stackFrame));
    });
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
      className: "mr-1 font-weight-bold"
    }, "Name:"), error.name), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
      className: "mr-1 font-weight-bold"
    }, "Message:"), error.message), /*#__PURE__*/React.createElement("ul", {
      className: "list-unstyled"
    }, stackFrames));
  };

  if (error instanceof ApiError) {
    return /*#__PURE__*/React.createElement("div", {
      className: "py-16p py-lg-0"
    }, /*#__PURE__*/React.createElement("div", {
      className: "container container-lg-fluid"
    }, /*#__PURE__*/React.createElement("div", {
      className: "alert alert-danger"
    }, /*#__PURE__*/React.createElement("p", {
      className: "mb-0"
    }, "http error")), printError()));
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "py-16p py-lg-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container container-lg-fluid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "alert alert-danger"
  }, /*#__PURE__*/React.createElement("p", {
    className: "mb-0"
  }, "Something went wrong:")), printError()));
};

export { ErrorFallback };